"use client"
import { motion } from "framer-motion"
import { FaBalanceScale, FaGavel, FaHandshake } from "react-icons/fa"

const HeroLaw = ({ titulo, subtitulo, imagenSrc, imagenAlt, botonTexto, onBotonClick }) => {
  const iconVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5,
        ease: "easeOut",
      },
    },
  }

  return (
    <div className="relative h-[95vh] w-full overflow-hidden lg:h-[75vh] ">
      <div
        className="absolute inset-0 bg-cover bg-center transform scale-105"
        style={{
          backgroundImage: `url(https://images.unsplash.com/photo-1505664194779-8beaceb93744?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80)`,
          filter: "brightness(0.6)",
        }}
      />
      <motion.div
        className="absolute inset-0"
        initial={{ scale: 1.1 }}
        animate={{ scale: 1 }}
        transition={{ duration: 10, ease: "easeOut" }}
      />
      <div className="relative z-10 flex flex-col items-center justify-center h-full text-white px-4">
        <motion.h1
          className="text-5xl md:text-7xl font-bold text-center mb-6"
          initial={{ opacity: 0, y: -50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, ease: "easeOut" }}
        >
          {titulo}
        </motion.h1>
        <motion.p
          className="text-xl md:text-3xl text-center mb-10 max-w-3xl"
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.2, ease: "easeOut" }}
        >
          {subtitulo}
        </motion.p>
        <motion.button
          type="submit"
          className="flex justify-center gap-2 items-center mx-auto shadow-xl text-lg bg-[var(--gold)] backdrop-blur-md lg:font-semibold isolation-auto border-gray-50 before:absolute before:w-full before:transition-all before:duration-700 before:hover:w-full before:-left-full before:hover:left-0 before:rounded-full before:bg-[var(--gold-dark)] hover:text-gray-50 before:-z-10 before:aspect-square before:hover:scale-150 before:hover:duration-700 relative z-10 px-4 py-2 overflow-hidden border-2 rounded-full group"
          onClick={onBotonClick}
          initial={{ opacity: 0, scale: 0.5 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.5, delay: 0.4 }}
          whileTap={{ scale: 0.95 }}
        >
          {botonTexto}
          <svg
            className="w-8 h-8 justify-end group-hover:rotate-90 group-hover:bg-gray-50 text-gray-50 ease-linear duration-300 rounded-full border border-white group-hover:border-none p-2 rotate-45"
            viewBox="0 0 16 19"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M7 18C7 18.5523 7.44772 19 8 19C8.55228 19 9 18.5523 9 18H7ZM8.70711 0.292893C8.31658 -0.0976311 7.68342 -0.0976311 7.29289 0.292893L0.928932 6.65685C0.538408 7.04738 0.538408 7.68054 0.928932 8.07107C1.31946 8.46159 1.95262 8.46159 2.34315 8.07107L8 2.41421L13.6569 8.07107C14.0474 8.46159 14.6805 8.46159 15.0711 8.07107C15.4616 7.68054 15.4616 7.04738 15.0711 6.65685L8.70711 0.292893ZM9 18L9 1H7L7 18H9Z"
              className="fill-white group-hover:fill-black"
            ></path>
          </svg>
        </motion.button>

        <motion.div
          className="flex justify-center mt-16 space-x-16"
          initial="hidden"
          animate="visible"
          transition={{ staggerChildren: 0.2, delayChildren: 0.6 }}
        >
          <motion.div variants={iconVariants} className="text-center">
            <FaBalanceScale className="text-4xl mb-2" />
            <p className="text-sm">Justicia Equitativa</p>
          </motion.div>
          <motion.div variants={iconVariants} className="text-center">
            <FaGavel className="text-4xl mb-2" />
            <p className="text-sm">Defensa Sólida</p>
          </motion.div>
          <motion.div variants={iconVariants} className="text-center">
            <FaHandshake className="text-4xl mb-2" />
            <p className="text-sm">Compromiso Total</p>
          </motion.div>
        </motion.div>
      </div>
    </div>
  )
}

export default HeroLaw

